function glideArrowStylingController(
  numberOfSlides,
  glide,
  arrowRightSelector,
  arrowLeftSelector,
  typeOfArrow = "red",
  visibilityControlClass = "opacity-50",
) {
  const perView = glide._o.perView;
  const arrowRight = document.querySelector(arrowRightSelector);
  const arrowLeft = document.querySelector(arrowLeftSelector);
  function makeArrowVisible(arrow) {
    if (typeOfArrow === "red") {
      arrow.removeAttribute("disabled");
      arrow.classList.remove(visibilityControlClass);
    } else {
      const activeArrow = arrow.querySelector(".active");
      const inactiveArrow = arrow.querySelector(".inactive");

      if (activeArrow && inactiveArrow) {
        activeArrow.classList.remove("hidden");
        inactiveArrow.classList.add("hidden");
        arrow.removeAttribute("disabled");
      }
    }
  }

  function makeArrowInvisible(arrow) {
    if (typeOfArrow === "red") {
      arrow.setAttribute("disabled", true);
      arrow.classList.add(visibilityControlClass);
    } else {
      const activeArrow = arrow.querySelector(".active");
      const inactiveArrow = arrow.querySelector(".inactive");

      if (activeArrow && inactiveArrow) {
        activeArrow.classList.add("hidden");
        inactiveArrow.classList.remove("hidden");
        arrow.setAttribute("disabled", true);
      }
    }
  }
  if (numberOfSlides > 1 && perView < numberOfSlides) {
    if (glide.index + perView === numberOfSlides) {
      makeArrowInvisible(arrowRight);
      makeArrowVisible(arrowLeft);
    } else if (glide.index === 0) {
      makeArrowVisible(arrowRight);
      makeArrowInvisible(arrowLeft);
    } else {
      makeArrowVisible(arrowRight);
      makeArrowVisible(arrowLeft);
    }
  } else if (numberOfSlides > 1 && perView >= numberOfSlides) {
    makeArrowInvisible(arrowRight);
    makeArrowInvisible(arrowLeft);
  }
}
